import { sidebarSlice } from "@/widgets/LayoutSidebar/model/slices";

import vatReturnSlice from "@/entities/ContentEntities/Vat/VatManagement/ui/GeneralTaxation/TaxReturn/model/slices/vatReturnSlice";
import xadomTableRowSlice from "@/shared/ui/XadomTable/model/row/slice";
import xadomTableSlice from "@/shared/ui/XadomTable/model/table/slice";
/**
 * Redux 리듀서 타입:
 * 
 * 1. 정적 리듀서 (Static Reducers)
 *    - 앱 전체 생명주기 동안 유지
 *    - 초기 로딩 시 포함
 *    - 기본 상태 관리 담당
 * 
 * 2. 동적 리듀서 (Dynamic Reducers)
 *    - injectReducer()를 통해 실행 중 추가
 *    - 필요할 때만 로드
 * 
 * 분리 사유:
 * - 초기 번들 크기 최적화
 * - 앱 초기 로딩 성능 향상
 * - 리소스 효율적 관리
 */

export const staticReducers = {
    sidebar: sidebarSlice.reducer,
    xadomTable: xadomTableSlice.reducer,
    xadomTableRow: xadomTableRowSlice.reducer,
    vatReturn: vatReturnSlice.reducer
};